// extracted by mini-css-extract-plugin
export var controlContainer = "styles-module__controlContainer___aL27K";
export var floatingContainer = "styles-module__floatingContainer___dP8rH";
export var routingControls = "styles-module__routingControls___yEWmn";
export var routingToggle = "styles-module__routingToggle___p8doA";